import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield, Lock, Database, Eye, UserCheck, Mail } from 'lucide-react';

const SECTIONS = [
  {
    icon: Database,
    title: 'Données que nous collectons',
    body: [
      "Mibeko a été conçue pour respecter votre vie privée. La quasi-totalité de vos usages restent sur votre téléphone (favoris, préférences de thème, article du jour) et ne quittent jamais votre appareil.",
      "Les seules informations transmises à nos serveurs sont : votre requête textuelle lorsque vous utilisez l'Assistant IA juridique, et — si vous les activez volontairement — l'abonnement anonyme aux notifications push (une identité technique fournie par votre navigateur / système, sans nom ni email).",
    ],
  },
  {
    icon: Eye,
    title: 'Ce que nous NE faisons PAS',
    body: [
      "Nous ne vendons ni ne louons aucune donnée à des tiers.",
      "Nous ne diffusons aucune publicité et n'intégrons aucun traceur publicitaire.",
      "Nous n'exigeons pas la création d'un compte pour lire les textes de loi.",
      "Nous ne partageons pas votre historique de recherche ou de conversation avec des tiers commerciaux.",
    ],
  },
  {
    icon: Lock,
    title: 'Sécurité et hébergement',
    body: [
      "Toutes les communications entre l'application et nos serveurs sont chiffrées en HTTPS (TLS).",
      "Les données transitent par une infrastructure cloud sécurisée, avec sauvegardes chiffrées et accès restreint aux administrateurs.",
      "Les questions posées à l'Assistant IA sont traitées via un prestataire tiers (OpenAI) uniquement le temps de générer la réponse ; nous ne conservons pas le contenu de vos conversations au-delà de la session en cours.",
    ],
  },
  {
    icon: UserCheck,
    title: 'Vos droits',
    body: [
      "Conformément à la Loi n° 22/041 du 4 juillet 2022 relative à la protection des données à caractère personnel en RDC, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition sur vos données.",
      "Pour exercer ces droits, désabonner votre appareil des notifications, ou signaler un incident, contactez-nous à l'adresse ci-dessous. Nous répondons sous 30 jours ouvrables.",
    ],
  },
  {
    icon: Mail,
    title: 'Nous contacter',
    body: [
      "MolaCorp — Éditeur de Mibeko",
      "Adresse électronique : contact@mibekordc.com",
      "Kinshasa, République Démocratique du Congo.",
    ],
  },
];

const PrivacyPage = () => {
  const navigate = useNavigate();
  return (
    <div data-testid="privacy-page">
      <div className="back-header">
        <button className="back-btn" onClick={() => navigate(-1)} data-testid="back-btn-privacy">
          <ArrowLeft />
        </button>
        <h1>Politique de confidentialité</h1>
      </div>

      <div className="blue-header" data-testid="privacy-header">
        <Shield style={{ width: 24, height: 24, marginBottom: 8, opacity: 0.85 }} />
        <h1>Politique de confidentialité</h1>
        <p>Comment Mibeko protège vos données — dernière mise à jour : 27 février 2026.</p>
      </div>

      <div className="page-container">
        <p style={{ fontSize: 14, color: 'var(--text-gray)', lineHeight: 1.6, marginBottom: 24 }}>
          Mibeko est une plateforme d'accès libre aux textes de lois de la République
          Démocratique du Congo. Nous croyons que le savoir juridique doit être accessible
          sans compromis sur votre vie privée. Cette politique décrit précisément ce que
          nous collectons, pourquoi, et ce que nous ne collectons jamais.
        </p>

        {SECTIONS.map((s, idx) => {
          const Icon = s.icon;
          return (
            <section key={idx} className="legal-section" data-testid={`privacy-section-${idx}`}>
              <div className="legal-section-head">
                <span className="legal-section-icon"><Icon /></span>
                <h2>{s.title}</h2>
              </div>
              {s.body.map((line, i) => (
                <p key={i} className="legal-section-body">{line}</p>
              ))}
            </section>
          );
        })}

        <p className="legal-footnote">
          Cette politique peut évoluer. Les modifications importantes vous seront signalées
          via la bannière de mise à jour de l'application.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPage;
